export function buildPlaybackRoutes({
  routes,
  onEnterAllSongsNowPlayingShortRoute,
  onEnterPodcast,
  createConditionalComponent,
  AsyncDomain,
  redirectToStationDetails,
  onEnterMyStations,
  onEnterNowPlayingOnDemand,
  onEnterPodcastNowPlaying,
  onLeaveNowPlaying,
  onEnterNowPlaying,
  onEnterNowPlayingSessionHistory,
}) {
  function buildPlayArtistShortRoute(artistPrefix) {
    return {
      path: `artist/play(/:artistName/${artistPrefix}:artistPandoraIdWithoutPrefix)`,
      props: {
        onMount: onEnterAllSongsNowPlayingShortRoute(artistPrefix),
        domain: 'playback',
      },
      component: AsyncDomain,
    };
  }

  function buildPlayArtistPseudoSourceRoute(artistPrefix) {
    return {
      path: `:parentType/play(/:pseudoType/:artistName/${artistPrefix}:artistPandoraIdWithoutPrefix)`,
      onEnter: onEnterNowPlayingOnDemand,
      onLeave: onLeaveNowPlaying,
      props: {
        component: 'NowPlaying',
        key: 'NowPlaying',
        domain: 'playback',
      },
      component: AsyncDomain,
    };
  }

  let finalRoutes = routes.concat([
    {
      /* backward compatible station edit urls we need to support */
      path: 'stations/edit/:stationId',
      onEnter: redirectToStationDetails,
    },
    {
      /* backward compatible station edit urls we need to support */
      path: 'stations/:stationId',
      onEnter: redirectToStationDetails,
    },
    {
      path: 'stations',
      onEnter: onEnterMyStations,
      props: {
        domain: 'playback',
        component: 'MyStations',
        key: 'MyStations',
      },
      component: AsyncDomain,
    },
    {
      path: 'station/play/thumbed-up/:stationThumbsPandoraId',
      onEnter: onEnterNowPlayingOnDemand,
      onLeave: onLeaveNowPlaying,
      props: {
        component: 'NowPlaying',
        key: 'NowPlaying',
        domain: 'playback',
      },
      component: AsyncDomain,
    },
    {
      path: 'station',
      onEnter: onEnterNowPlaying,
      onLeave: onLeaveNowPlaying,
      props: {
        domain: 'playback',
        component: 'NowPlaying',
        key: 'NowPlaying',
      },
      component: AsyncDomain,
      childRoutes: [
        {
          /* known entry path, parent component will redirect to final location */
          path: 'start/:seoToken',
        },
        {
          path: 'play/:stationId',
          childRoutes: [
            {
              /* supporting legacy path now managed by app state, redirects to parent location */
              path: 'history',
              onEnter: onEnterNowPlayingSessionHistory,
            },
          ],
        },
        {
          path: '(play/:stationId/:trackToken)',
        },
      ],
    },
    {
      path: '/my-music/play/:pseudoType',
      onEnter: onEnterNowPlayingOnDemand,
      onLeave: onLeaveNowPlaying,
      props: {
        component: 'NowPlaying',
        key: 'NowPlaying',
        domain: 'playback',
      },
      component: AsyncDomain,
    },
  ]);

  finalRoutes = finalRoutes.concat([
    {
      path: 'playlist/play/:playlistPandoraId',
      onEnter: onEnterNowPlayingOnDemand,
      onLeave: onLeaveNowPlaying,
      props: {
        component: 'NowPlaying',
        key: 'NowPlaying',
        domain: 'playback',
      },
      component: AsyncDomain,
    },
    {
      path: 'artist/play(/:artistName/:albumName/AL:albumPandoraIdWithoutPrefix)',
      onEnter: onEnterNowPlayingOnDemand,
      onLeave: onLeaveNowPlaying,
      props: {
        component: 'NowPlaying',
        key: 'NowPlaying',
        domain: 'playback',
      },
      component: AsyncDomain,
    },
    {
      path: 'podcast/play(/:programName/:episodeName/:episodePandoraId)',
      onEnter: onEnterPodcastNowPlaying,
      onLeave: onLeaveNowPlaying,
      props: {
        domain: 'playback',
        component: 'NowPlaying',
        key: 'NowPlaying',
      },
      component: AsyncDomain,
    },
    {
      path: 'podcast/play/:programName/:podcastPandoraId',
      onEnter: onEnterPodcastNowPlaying,
      onLeave: onLeaveNowPlaying,
      props: {
        domain: 'playback',
        component: 'NowPlaying',
        key: 'NowPlaying',
      },
      component: AsyncDomain,
    },
    {
      path: 'artist/play(/:artistName/:albumName/:songName/:trackPandoraId)',
      onEnter: onEnterNowPlayingOnDemand,
      onLeave: onLeaveNowPlaying,
      props: {
        component: 'NowPlaying',
        key: 'NowPlaying',
        domain: 'playback',
      },
      component: AsyncDomain,
    },
    buildPlayArtistShortRoute('AR'),
    buildPlayArtistShortRoute('CO'),
    buildPlayArtistPseudoSourceRoute('AR'),
    buildPlayArtistPseudoSourceRoute('CO'),
  ]);

  return finalRoutes;
}

export default {
  buildPlaybackRoutes,
};
